import { Injectable } from '@angular/core';

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [
  { state: 'chef-courrier', name: 'Dashboard', type: 'link', icon: 'dashboard', priv: 'up_colis', children: [] },
  { state: 'chef-courrier/alert-dashboard', name: 'alertdashboard', type: 'link', icon: 'warning', priv: 'up_colis', children: [] },
  { state: 'bagage\/autre', type: 'link', name: 'autresentre', icon: 'all_inclusive' , priv: 'cr_recette', children: []},
  { state: 'collis\/mail', type: 'link', name: 'listcollis', icon: 'view_list' , priv: 'rd_colis', children: []},
  { state: 'collis\/retrait', type: 'link', name: 'retraitcollis', icon: 'remove_from_queue' , priv: 'rd_retrait', children: []},
  { state: 'bagage\/list', type: 'link', name: 'listbagage', icon: 'view_list' , priv: 'rd_bagage', children: []},
  { state: 'bordeaureau', type: 'link', name: 'gestionbordeaureaux', icon: 'content_paste_go' , priv: 'cr_bordereau', children: []},
  { state: 'listbordeaureau', type: 'link', name: 'listbordeaureaux', icon: 'content_paste_search' , priv: 'rd_bordereau', children: []},
  { state: 'listbordeaureau\/externe', type: 'link', name: 'listbordeaureau', icon: 'pending_actions' , priv: 'rd_bordereauext', children: []},
  { state: 'free', type: 'link', name: 'freecode', icon: 'shuffle' , priv: 'rd_freeticket', children: []},
  { state: 'session\/usersession', type: 'link', name: 'raportsessions', icon: 'insights' , priv: 'cr_colis', children: []},
  { state: 'session', type: 'link', name: 'raportsession', icon: 'update' , priv: 'rd_session', children: []},
  { state: 'client', type: 'link', name: 'client', icon: 'groups' , priv: 'rd_setting', children: []},
  { state: 'logs', type: 'link', name: 'colislogs', icon: 'psychology' , priv: 'rd_colislogs', children: []},
  { state: 'fiscalite/month-preview', type: 'link', name: 'monthPreview', icon: 'calendar_month', priv: 'rd_fiscalite', children: [] },
  { state: 'collis/claims', type: 'link', name: 'Claims Follow-up', icon: 'gavel', priv: 'rd_colis', children: [] },
];

@Injectable()
export class MenuItemsChefCourrier {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
